import uuidv1 from 'uuid/v1';

// HEAD DATA
export const headData = {
  title: 'Tanishq Gautam | Web Developer', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Welcome', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Hey, I am ',
  name: 'Tanishq Gautam',
  subtitle: 'I am a Web Developer ',
  cta: 'Find out more about me',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne: 'Hi!, I am a 21 year old Web Developer based in Bangalore India',
  paragraphTwo:
    'I am a full-time student, so I treat development as I do school—I am always learning, whether it be through working on cool projects or hearing other developers experiences.',
  paragraphThree:
    'I am quietly confident, naturally curious, and perpetually working on improving my chops one design problem at a time.',
  resume: '', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: uuidv1(),
    img: 'project1.jpg',
    title: 'Weatherry',
    info:
      'A Simple Weather app that allows you to search for Temperature , Humidity and other conditions in a city of your choice. ',
    info2: 'This project is bootstrapped with Create React App and Api is extracted from ',
    url: 'https://weatherry.netlify.com',
    repo: 'hhttps://github.com/jelifysh/Weatherry', // if no repo, the button will not show up
  },
  {
    id: uuidv1(),
    img: 'projecttwo.jpg',
    title: 'Rock, Paper and Scissor',
    info: 'My first Front-End game from scratch using Vanilla Javascript, CSS3 and HTML5.',
    info2: '',
    url: 'https://jelifysh.github.io/rps/',
    repo: 'https://github.com/jelifysh/rps', // if no repo, the button will not show up
  },
  {
    id: uuidv1(),
    img: 'project3.jpg',
    title: 'Pomodoro Clock',
    info: 'A pomodoro clock build using React. Designed based on a pen by Edd Yerburgh.',
    info2:
      'The Pomodoro Technique is a time-management framework which is as simple as it is effective - you use a timer to break your work into time blocks (usually 25 minutes), separated by a 5 minute break. After every 4 pomodoros, you can take a longer break.',
    url: 'https://thepomodoroclock.netlify.com',
    repo: 'https://github.com/jelifysh/PomodoroClock/', // if no repo, the button will not show up
  },
  {
    id: uuidv1(),
    img: 'project4.jpg',
    title: 'Guess the Square',
    info: 'A Shell Game representation written using React.',
    info2: '',
    url: 'https://guessthesquare.netlify.com',
    repo: 'https://github.com/jelifysh/guessthesquare/', // if no repo, the button will not show up
  },
  {
    id: uuidv1(),
    img: 'project5.jpg',
    title: 'Netflix Clone',
    info:
      'Netflix Clone front page in React using React Router 4 for the routing throughout the application.',
    info2: 'styled-components for styling and CSS Grid for the tabs react-tabs library.',
    url: 'https://anetflixclone.netlify.com',
    repo: 'https://github.com/jelifysh/NetflixClone/', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: 'Would you like to work with me? Awesome!',
  btn: 'Contact Me',
  email: 'tanishqgautam98@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: uuidv1(),
      name: 'twitter',
      url: 'https://twitter.com/JeliFyshh',
    },
    {
      id: uuidv1(),
      name: 'codepen',
      url: 'https://codepen.io/LightFeather',
    },
    {
      id: uuidv1(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/tanishq-gautam-b00632192/',
    },
    {
      id: uuidv1(),
      name: 'github',
      url: 'https://github.com/jelifysh',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
